__turbopack_context__.v({
  "desktopLogo": "Logo-module-scss-module__ZKzedW__desktopLogo",
  "mobileLogo": "Logo-module-scss-module__ZKzedW__mobileLogo",
});
